import { styled } from 'config/stitches/stitches';

export const Container = styled('nav', {
  position: 'fixed',
  backgroundColor: '#ffffff',
  width: '72px',
  height: '100%',
  zIndex: '1',
  top: 48,
  left: -1,
  border: '1px solid $BORDER_NEUTRAL_DEFAULT',
});

export const Content = styled('ul', {
  listStyle: 'none',
  margin: 0,
  padding: 0,
  width: '100%',
  height: '100%',
});

export const Item = styled('li', {
  position: 'relative',
  margin: 0,
  padding: 0,
  width: '100%',
  height: '64px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  cursor: 'pointer',

  '&:hover': {
    background: '$BORDER_NEUTRAL_DEFAULT',
  },

  variants: {
    isActive: {
      true: {
        background: '#EBEBEB',
        '&::before': {
          content: '',
          position: 'absolute',
          left: 0,
          top: -1,
          minWidth: '4px',
          height: '100%',
          background: '$BORDER_ACCENT_DEFAULT',
          borderRadius: '4px',
          pointerEvents: 'none',
        },
      },
    },
  },
});

export const Text = styled('span', {
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '16px',
  whiteSpace: 'nowrap',
  color: '$CONTENT_PRIMARY',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  maxWidth: 50,
});

export const Icon = styled('div', {
  width: '24px',
  minWidth: '24px',
  color: '$CONTENT_PRIMARY',
});

export const MenuContainer = styled('div', {
  position: 'fixed',
  backgroundColor: 'white',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: '4px',
  zIndex: 1000,
  minWidth: '180px',
  maxHeight: '400px',
  overflowY: 'auto',
});

export const MenuItem = styled('div', {
  padding: '8px 16px',
  fontSize: '12px',
  color: '$CONTENT_PRIMARY',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: '$BORDER_NEUTRAL_DEFAULT',
  },
});
